import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument], $slug: [String], $draftId: Int, $revisionId: Int) {
        data: entry(section: "homePage", siteId: $siteId, slug: $slug, draftId: $draftId, revisionId: $revisionId) {
            id
            title
            ... on homePage_Entry {
                userStatus
                seoMetaTitle
                seoMetaDescription
                matrix: pageMatrix {
                    ... on accordion_Entry {
                        type: typeHandle
                        identifier
                        accordion: sections {
                            ... on sectionsBlock_Entry {
                                label
                                body
                            }
                        }
                    }
                    ... on body_Entry {
                        type: typeHandle
                        body
                        backgroundImage {
                            url
                        }
                        backgroundImageMobile {
                            url
                        }
                        video2 {
                            url
                        }
                        mobileVideo2 {
                            url
                        }
                        bgMobileBreakpoint
                        backgroundColor
                        fullWidth
                        cssClasses
                    }
                    ... on ad2_Entry {
                        type: typeHandle
                        adUnit
                        sizes {
                            ... on sizesBlock_Entry {
                                width
                                height
                            }
                        }
                    }
                    ... on courseDirectors_Entry {
                        type: typeHandle
                        head
                        roles
                        rolesToSuppress
                        backgroundColor
                        highlightColor
                        fullWidth
                        layout
                        backgroundImage {
                            url
                        }
                    }
                    ... on customComp_Entry {
                        type: typeHandle
                        component
                        customClass
                        json
                        contentBlox {
                            ... on contentBloxBlock_Entry {
                                block
                            }
                        }
                        parameters {
                            value
                        }
                    }
                    ... on hero_Entry {
                        type: typeHandle
                        backgroundImage {
                            url
                        }
                        logo {
                            url
                        }
                        video {
                            url
                        }
                        maxWidth
                        backgroundColor
                        marginLeft
                    }
                    ... on twoColumn_Entry {
                        type: typeHandle
                        widths
                        columnOne
                        columnTwo
                        gap
                        cssClass
                        verticalColumnDivider
                    }
                    ... on row_Entry {
                        type: typeHandle
                        customClass
                        addDividers
                        gapHorizontal
                        gapVerticalMobile
                        columnsContent {
                            ... on columnsContentBlock_Entry {
                                columnContent
                            }
                        }
                    }
                    ... on socialMedia_Entry {
                        type: typeHandle
                        text
                        color
                        hoverColor
                        backgroundColor
                    }
                    ... on wrapper_Entry {
                        type: typeHandle
                        customClass
                        entries {
                            ... on page_Entry {
                                id
                                pageMatrix {
                                    ... on body_Entry {
                                        type: typeHandle
                                        title
                                        body
                                        cssClasses
                                    }
                                    ... on accordion_Entry {
                                        type: typeHandle
                                        style
                                        identifier
                                        showExpandAllButton
                                        accordion: sections {
                                            ... on sectionsBlock_Entry {
                                                label
                                                body
                                            }
                                        }
                                    }
                                    ... on row_Entry {
                                        type: typeHandle
                                        customClass
                                        addDividers
                                        gapHorizontal
                                        gapVerticalMobile
                                        columnsContent {
                                            ... on columnsContentBlock_Entry {
                                                columnContent
                                            }
                                        }
                                    }
                                    ... on twoColumn_Entry {
                                        type: typeHandle
                                        widths
                                        columnOne
                                        columnTwo
                                        gap
                                        cssClass
                                        verticalColumnDivider
                                    }
                                    ... on customComp_Entry {
                                        type: typeHandle
                                        component
                                        customClass
                                        json
                                        contentBlox {
                                            ... on contentBloxBlock_Entry {
                                                block
                                            }
                                        }
                                        parameters {
                                            value
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
